module.exports = __webpack_public_path__ + "static/media/logo-donts-4.3629d625.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo-donts-4.png
// module id = 1307
// module chunks = 0